export enum RetailerConfig {
	General = "general",
	App = "app",
	Identity = "identity",
}
